export default __webpack_public_path__ + "static/media/banner_login.a29519ff.jpeg";